import React from 'react';
import { IPlanPhoto } from '../../../types/plans';
import { Helmet } from 'react-helmet';

interface PlanViewImageProps {
  image: string;
  photos: IPlanPhoto[];
  alt?: string;
}

export const PlanViewImage = ({ image, photos, alt = 'Configure' }: PlanViewImageProps) => {
  const [primaryImage] = photos.filter((p: IPlanPhoto) => !!p.isPrimary);
  if (primaryImage && primaryImage.original) {
    image = primaryImage.original;
  } else if (primaryImage && primaryImage.compressed?.url) {
    image = primaryImage.compressed?.url;
  }

  return (
    <>
      <Helmet>
        <meta property="og:image" key="og:image" content={image} />
      </Helmet>
      <img
        src={image}
        alt={alt}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
      />
    </>
  );
};
